import { S3FileUploader } from "@contember/client";
const defaultUploader = new S3FileUploader();
export {
  defaultUploader
};
//# sourceMappingURL=defaultUploader.js.map
